export default "__VITE_ASSET__DmMJPM5Y__"